import React from "react"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import parse from 'html-react-parser'
import { Arrow } from "../icons"

const TeamCard = (props) => {

  if  (!props) {
    return null
  }

  return (
    <Link to={props.permalink} className="card card--team">
      <div className="card--team__image">
        {props.thumbnail && <Asset asset={props.thumbnail} />}
      </div>

      <div className="card--team__info">
        {props.title && <h3>{parse(props.title)}</h3>}
        {props.jobTitle && <span>{parse(props.jobTitle)}</span>}
        {props.permalink && <span to={props.permalink}><Arrow/></span>}
      </div>
    </Link>
  )
}

export default TeamCard
